module.exports = __webpack_public_path__ + "img/figure-ico.8ffa8020.svg";